import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TFMService } from 'app/mock-api/tfm.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-bookconfirmationmodal',
  standalone: true,
  imports: [],
  templateUrl: './bookconfirmationmodal.component.html',
  styleUrl: './bookconfirmationmodal.component.scss'
})
export class BookconfirmationmodalComponent {
  bookCompleted$ = new Subject<boolean>();

  public view: any = {}

  constructor(private tfmService: TFMService, public dialogRef: MatDialogRef<BookconfirmationmodalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.view.data = data.quote;
      this.view.itinerary = data.quote.itinerary;
  }
  async itinPersonAdd(itinOption, book = false) {
    //var itinGuid = this.tfmService.getLocalItinGuid();
    console.log("OPTION", itinOption, this.view);
    this.close();
    var content: any = {};

    await this.tfmService.getItin(this.view.data.itinerary.guid).subscribe(async (res) => {
      console.log(res);

      if (this.view.data.items) {
        console.log("this.view.itineraryOption.items", this.view.data.items)
        this.view.occupancy = [];
        var occupancy: any[] = [];
        var count = 0;
        //Generate occupancy based on accommodation items
        this.view.data.items.content.forEach(item => {
          if (item.searchType == 1) {
            //Get existing pax mapped
            count++;
            this.tfmService.filterAndSend(item._links, "persons").subscribe(resItemPersons => {
              count--;
              //console.log(resItemPersons);

              var adults = resItemPersons.content.filter(x => x.type == 1);
              var teens = resItemPersons.content.filter(x => x.type == 3);
              var children = resItemPersons.content.filter(x => x.type == 2);
              var infants = resItemPersons.content.filter(x => x.type == 4);

              var childAgesSplit = item.childAges ? item.childAges.split(",") : [];

              adults.filter(x => x.dateOfBirth).forEach(pax => {
                pax.dateOfBirth = pax.dateOfBirth ? new Date(pax.dateOfBirth) : null;
                if (pax.dateOfBirth)
                  pax.dateOfBirth.setHours(pax.dateOfBirth.getHours() + 2);

                pax.dateOfBirth = new Date(pax.dateOfBirth).toISOString().substring(0, 10);
                pax.minDate = this.tfmService.subtractYears(new Date(), 18);
              });
              teens.filter(x => x.dateOfBirth).forEach(pax => {
                pax.dateOfBirth = pax.dateOfBirth ? new Date(pax.dateOfBirth) : null;
                if (pax.dateOfBirth)
                  pax.dateOfBirth.setHours(pax.dateOfBirth.getHours() + 2);

                pax.dateOfBirth = new Date(pax.dateOfBirth).toISOString().substring(0, 10);
              });
              children.filter(x => x.dateOfBirth).forEach((pax, x) => {
                pax.dateOfBirth = pax.dateOfBirth ? new Date(pax.dateOfBirth) : null;
                if (pax.dateOfBirth)
                  pax.dateOfBirth.setHours(pax.dateOfBirth.getHours() + 2);

                pax.dateOfBirth = new Date(pax.dateOfBirth).toISOString().substring(0, 10);
                pax.minDate = this.tfmService.subtractYears(new Date(), childAgesSplit && childAgesSplit.length > x ? childAgesSplit[x] : 12)
              });
              infants.filter(x => x.dateOfBirth).forEach(pax => {
                pax.dateOfBirth = pax.dateOfBirth ? new Date(pax.dateOfBirth) : null;
                if (pax.dateOfBirth)
                  pax.dateOfBirth.setHours(pax.dateOfBirth.getHours() + 2);

                pax.dateOfBirth = new Date(pax.dateOfBirth).toISOString().substring(0, 10);
              });

              var occ = {
                id: item.id,
                adultCount: item.adultCount,
                adults: adults,
                teenCount: item.teenCount,
                teens: teens,
                childCount: item.childCount,
                children: children,
                childAges: item.childAges,
                infantCount: item.infantCount,
                infants: infants,
                item: item
              };

              for (var x = occ.adults.length; x < occ.adultCount; x++) {
                occ.adults.push({
                  minDate: this.tfmService.subtractYears(new Date(), 18)
                });
              }
              for (var x = occ.teens.length; x < occ.teenCount; x++) {
                occ.teens.push({});
              }
              for (var x = occ.children.length; x < occ.childCount; x++) {
                occ.children.push({
                  minDate: this.tfmService.subtractYears(new Date(), childAgesSplit && childAgesSplit.length > x ? childAgesSplit[x] : 12)
                });
              }
              for (var x = occ.infants.length; x < occ.infantCount; x++) {
                occ.infants.push({});
              }

              occupancy.push(occ);

              if (count == 0) {
                this.view.occupancy = occupancy.sort((a, b) => a.id - b.id);
              }
            });
          }
        });
      }

      await this.tfmService.filterAndSend(res.content.itinerary._links, "persons").subscribe(async (resPersons) => {
        console.log("PERSONS", resPersons);

        for await (const [roomIndex, room] of this.view.occupancy.entries()) {
          //this.view.occupancy.forEach((room, roomIndex) => {
          for await (const [index, p] of room.adults.entries()) {
            //room.adults.forEach((p, index) => {
            p.dateOfBirth = p.dateOfBirth ? new Date(p.dateOfBirth) : null;
            if (p.dateOfBirth)
              p.dateOfBirth.setHours(p.dateOfBirth.getHours() + 2);

            content = {
              IsLead: roomIndex == 0 && index == 0,
              Title: p.title,
              EmailAddress: p.emailAddress,
              FirstName: p.firstName,
              LastName: p.lastName,
              CountryAccessCode: p.countryAccessCode,
              AreaCityCode: p.areaCityCode,
              PhoneNumber: p.phoneNumber,
              Type: 1,
              Notes: p.notes,
              DateOfBirth: p.dateOfBirth
            };

            //Check if we have this person type already in the list, and just update it
            if (resPersons.content.filter(x => x.type == content.Type).length > (roomIndex + index)) {
              p.id = resPersons.content.filter(x => x.type == content.Type)[(roomIndex + index)].id;
            }

            if (p.id > 0) { //Existing person, just update their details
              await this.tfmService.filterAndSendAsPromise(resPersons.content.filter(x => x.id == p.id)[0]._links, "edit", content).then(async (resPersonAdd) => {
                console.log("Pax updated");
              });
            }
            else { //Add new person and map to service items
              await this.tfmService.filterAndSendAsPromise(resPersons._links, "add", content).then(async (resPersonAdd) => {
                //console.log("Pax added");
                //console.log("PERSON ADD", resPersonAdd);

                //Assign person to items
                for await (const [itemIndex, item] of itinOption.items.content.entries()) {
                  //itinOption.items.content.forEach(async (item) => {
                  if (item.searchType != 1 || (item.searchType == 1 && (!room.item || item.id == room.item.id))) { //Only map this person to this accommodation item if it matches - all other services get all pax mapped
                    await this.tfmService.filterAndSendAsPromise(item._links, "persons").then(async (resItemPersons) => {
                      let link = this.tfmService.getLink(resItemPersons._links, "add");
                      link.href = link.href.replace("{personId}", resPersonAdd.id);

                      await this.tfmService.send(link).subscribe(resItemPersonAdd => {
                        console.log("Pax added");
                        //console.log("PERSON ADDDED TO ITEM", resItemPersonAdd);
                      });
                    });
                  }
                };
              });
            }
          };
          for await (const [index, p] of room.teens.entries()) {
            //room.teens.forEach((p, index) => {
            p.dateOfBirth = p.dateOfBirth ? new Date(p.dateOfBirth) : null;
            if (p.dateOfBirth)
              p.dateOfBirth.setHours(p.dateOfBirth.getHours() + 2);

            content = {
              IsLead: 0,
              Title: p.title,
              EmailAddress: p.emailAddress,
              FirstName: p.firstName,
              LastName: p.lastName,
              CountryAccessCode: p.countryAccessCode,
              AreaCityCode: p.areaCityCode,
              PhoneNumber: p.phoneNumber,
              Type: 3,
              Notes: p.notes,
              DateOfBirth: p.dateOfBirth
            };

            //Check if we have this person type already in the list, and just update it
            if (resPersons.content.filter(x => x.type == content.Type).length > (roomIndex + index)) {
              p.id = resPersons.content.filter(x => x.type == content.Type)[(roomIndex + index)].id;
            }

            if (p.id > 0) { //Existing person, just update their details
              await this.tfmService.filterAndSendAsPromise(resPersons.content.filter(x => x.id == p.id)[0]._links, "edit", content).then(async (resPersonAdd) => {
                console.log("Pax updated");
              });
            }
            else { //Add new person and map to service items
              await this.tfmService.filterAndSendAsPromise(resPersons._links, "add", content).then(async (resPersonAdd) => {
                //console.log("Pax added");
                //console.log("PERSON ADD", resPersonAdd);

                //Assign person to items
                for await (const [itemIndex, item] of itinOption.items.content.entries()) {
                  //itinOption.items.content.forEach(item => {
                  if (item.searchType != 1 || (item.searchType == 1 && (!room.item || item.id == room.item.id))) { //Only map this person to this accommodation item if it matches - all other services get all pax mapped
                    await this.tfmService.filterAndSendAsPromise(item._links, "persons").then(async (resItemPersons) => {
                      let link = this.tfmService.getLink(resItemPersons._links, "add");
                      link.href = link.href.replace("{personId}", resPersonAdd.id);

                      await this.tfmService.send(link).subscribe(resItemPersonAdd => {
                        console.log("Pax added");
                        //console.log("PERSON ADDDED TO ITEM", resItemPersonAdd);
                      });
                    });
                  }
                };
              });
            }
          };
          for await (const [index, p] of room.children.entries()) {
            //room.children.forEach((p, index) => {
            p.dateOfBirth = p.dateOfBirth ? new Date(p.dateOfBirth) : null;
            if (p.dateOfBirth)
              p.dateOfBirth.setHours(p.dateOfBirth.getHours() + 2);

            content = {
              IsLead: 0,
              Title: p.title,
              EmailAddress: p.emailAddress,
              FirstName: p.firstName,
              LastName: p.lastName,
              CountryAccessCode: p.countryAccessCode,
              AreaCityCode: p.areaCityCode,
              PhoneNumber: p.phoneNumber,
              Type: 2,
              Notes: p.notes,
              DateOfBirth: p.dateOfBirth
            };

            //Check if we have this person type already in the list, and just update it
            if (resPersons.content.filter(x => x.type == content.Type).length > (roomIndex + index)) {
              p.id = resPersons.content.filter(x => x.type == content.Type)[(roomIndex + index)].id;
            }

            if (p.id > 0) { //Existing person, just update their details
              await this.tfmService.filterAndSendAsPromise(resPersons.content.filter(x => x.id == p.id)[0]._links, "edit", content).then(async (resPersonAdd) => {
                console.log("Pax updated");
              });
            }
            else { //Add new person and map to service items
              await this.tfmService.filterAndSendAsPromise(resPersons._links, "add", content).then(async (resPersonAdd) => {
                //console.log("Pax added");
                //console.log("PERSON ADD", resPersonAdd);

                //Assign person to items
                for await (const [itemIndex, item] of itinOption.items.content.entries()) {
                  //itinOption.items.content.forEach(item => {
                  if (item.searchType != 1 || (item.searchType == 1 && (!room.item || item.id == room.item.id))) { //Only map this person to this accommodation item if it matches - all other services get all pax mapped
                    await this.tfmService.filterAndSendAsPromise(item._links, "persons").then(async (resItemPersons) => {
                      let link = this.tfmService.getLink(resItemPersons._links, "add");
                      link.href = link.href.replace("{personId}", resPersonAdd.id);

                      await this.tfmService.send(link).subscribe(resItemPersonAdd => {
                        console.log("Pax added");
                        //console.log("PERSON ADDDED TO ITEM", resItemPersonAdd);
                      });
                    });
                  }
                };
              });
            }
          };
          for await (const [index, p] of room.infants.entries()) {
            //room.infants.forEach((p, index) => {
            p.dateOfBirth = p.dateOfBirth ? new Date(p.dateOfBirth) : null;
            if (p.dateOfBirth)
              p.dateOfBirth.setHours(p.dateOfBirth.getHours() + 2);

            content = {
              IsLead: 0,
              Title: p.title,
              EmailAddress: p.emailAddress,
              FirstName: p.firstName,
              LastName: p.lastName,
              CountryAccessCode: p.countryAccessCode,
              AreaCityCode: p.areaCityCode,
              PhoneNumber: p.phoneNumber,
              Type: 4,
              Notes: p.notes,
              DateOfBirth: p.dateOfBirth
            };

            //Check if we have this person type already in the list, and just update it
            if (resPersons.content.filter(x => x.type == content.Type).length > (roomIndex + index)) {
              p.id = resPersons.content.filter(x => x.type == content.Type)[(roomIndex + index)].id;
            }

            if (p.id > 0) { //Existing person, just update their details
              await this.tfmService.filterAndSendAsPromise(resPersons.content.filter(x => x.id == p.id)[0]._links, "edit", content).then(async (resPersonAdd) => {
                console.log("Pax updated");
              });
            }
            else { //Add new person and map to service items
              await this.tfmService.filterAndSendAsPromise(resPersons._links, "add", content).then(async (resPersonAdd) => {
                //console.log("Pax added");
                //console.log("PERSON ADD", resPersonAdd);

                //Assign person to items
                for await (const [itemIndex, item] of itinOption.items.content.entries()) {
                  //itinOption.items.content.forEach(item => {
                  if (item.searchType != 1 || (item.searchType == 1 && (!room.item || item.id == room.item.id))) { //Only map this person to this accommodation item if it matches - all other services get all pax mapped
                    await this.tfmService.filterAndSendAsPromise(item._links, "persons").then(async (resItemPersons) => {
                      let link = this.tfmService.getLink(resItemPersons._links, "add");
                      link.href = link.href.replace("{personId}", resPersonAdd.id);

                      await this.tfmService.send(link).subscribe(resItemPersonAdd => {
                        console.log("Pax added");
                        //console.log("PERSON ADDDED TO ITEM", resItemPersonAdd);
                      });
                    });
                  }
                };
              });
            }
          };
        };

        setTimeout(() => {
          this.itinPreBook(this.view.data.itinerary.guid, book);
        }, 3000);
      });
    });
  }
  itinPreBook(itinGuid, book = false) {
    //var itinGuid = this.tfmService.getLocalItinGuid();

    this.tfmService.getItin(itinGuid).subscribe(res => {
      res.content.itinerary.remarks = this.view.itinerary.remarks;

      this.tfmService.filterAndSend(res.content.itinerary._links, "edit", res.content.itinerary).subscribe(resItin => {
        console.log("Remarks added...");

        this.tfmService.filterAndSend(res.content.itinerary._links, "prebook").subscribe(resPrebook => {
          console.log("Prebook complete");
          //console.log("PREBOOK", resPrebook);
          if (book)
            this.itinBook();
          else
            this.itinOptionsLoad();
        });
      });
    });
  }


  itinBook() {
    var itinGuid = this.tfmService.getLocalItinGuid();

    this.tfmService.getItin(itinGuid).subscribe(res => {
      this.tfmService.filterAndSend(res.content.itinerary._links, "book").subscribe(resBook => {
       // this.toaster.success("Booking made");
        //console.log("BOOK", resBook);

        //Update itin status
        res.content.itinerary.status = 1;
        this.tfmService.filterAndSend(res.content.itinerary._links, "edit", res.content.itinerary).subscribe(resBook => {
          //this.toaster.success("Status changed");
        });
        this.itinOptionsLoad();
          this.bookCompleted$.next(true);
        this.bookCompleted$.complete();
      });
    });
  }
itinOptionsLoad(){
        var itinGuid = this.tfmService.getLocalItinGuid();

this.tfmService.getItinOptions(itinGuid).subscribe(resOptions => {

      var res = resOptions.content;

      res.forEach(option => {
        this.tfmService.getItinItems(option.itinerary.guid).subscribe(optionItems => {
          option.itinerary.items = optionItems;

          this.tfmService.filterAndSend(option.itinerary._links, "payments").subscribe(res => {
            option.itinerary.payments = res;
          });
        });

        // this.getPayments(option.itinerary);
        // console.log("getPayments");
      });
    });
  }
  close(): void {
    this.dialogRef.close(false);
  }

}
